"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import { ItemContainer } from '../Item/Item.mjs';
import { useList } from '../../../../hooks/useList.mjs';
import { cloneElement } from 'react';
import { ListItemSkeletonView } from '../Item/components/ListItemSkeletonView/ListItemSkeletonView.mjs';

const FallbackItems = () => {
  const list = useList();
  const fallback = list.itemView?.fallback ?? /* @__PURE__ */ jsx(ListItemSkeletonView, { viewMode: list.viewMode });
  return Array.from(Array(5)).map((_, i) => /* @__PURE__ */ jsx(ItemContainer, { id: i, data: i, children: cloneElement(fallback) }, i));
};

export { FallbackItems };
//# sourceMappingURL=FallbackItems.mjs.map
